import { getPaginatedVulnerabilityDetails } from "extensions/usoc/api/security";
import useSWR from "swr"

const deduplicateVulns = (allVulns) => {
    const dedupMap = new Map();
    allVulns.forEach(item => {
        if (!item.resource_id || !item.plugin_id) return;
        const key = `${item.resource_id}|${item.plugin_id}`;
        if (!dedupMap.has(key)) dedupMap.set(key, item);
    });
    return Array.from(dedupMap.values());
};

const fetchAllPagesForSeverity = async (severity, auth, host, projectID) => {
    if (!host || !projectID) throw new Error("Missing host or projectID");
    const page1Params = `severity=${severity}&bookmark=OS&page_size=500&page=1`
    const firstPage = await getPaginatedVulnerabilityDetails({ auth, host }, projectID, page1Params);
    if (firstPage.error) {
        throw firstPage.error;
    }
    const responseData = firstPage.data || firstPage;
    const vulnerabilities = [...(responseData.vulnerabilities || [])];
    const pagination = responseData.pagination || {};
    const totalPages = pagination.total_pages || 1;

    if (totalPages > 1) {
        const pagePromises = [];
        for (let page = 2; page <= totalPages; page++) {
            const pageParams = `severity=${severity}&bookmark=OS&page_size=500&page=${page}`;
            pagePromises.push(
                getPaginatedVulnerabilityDetails(
                    { auth, host },
                    projectID,
                    pageParams
                )
            );
        }
        const pageResults = await Promise.all(pagePromises);
        pageResults.forEach((res) => {
            if (res.error) {
                throw res.error
            }
            const resData = res.data || res;
            if (resData && Array.isArray(resData.vulnerabilities)) {
                vulnerabilities.push(...resData.vulnerabilities);
            }
        });
    }
    return vulnerabilities;
};

const fetchAllSeveritiesVulns = async ({ auth, host, projectID }) => {
    const severities = ["HIGH", "CRITICAL", "MEDIUM"];
    try {
        const allResults = await Promise.all(
            severities.map(severity =>
                fetchAllPagesForSeverity(severity, auth, host, projectID)
            )
        );
        let allVulns = allResults.flat();
        return deduplicateVulns(allVulns);
    } catch (e) {
        throw e;
    }
};

export default function useAllVulnerabilities(auth, projectID, extension) {
    const host = extension?.config?.env?.clientApiGateway?.URL;
    console.log(host);
    console.log(projectID);
    return useSWR(
        auth && host && projectID
            ? ["allVulns", host, projectID]
            : null,
        () => fetchAllSeveritiesVulns({ auth, host, projectID })
    );
}